var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoyTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 131,
    viewBox: "0 0 123 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1048_1636)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1048_1636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 30C2 14.536 14.536 2 30 2H113C117.418 2 121 5.58172 121 10V101C121 116.464 108.464 129 93 129H30C14.536 129 2 116.464 2 101V30Z",
    fill: "#9DB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4471 91.2301C17.3028 98.3943 13.7697 118.85 15.3034 128.606C15.3399 128.838 15.5408 129 15.7763 129H92.6276C92.8565 129 93.0561 128.833 93.1019 128.609C97.9936 104.669 78.2445 93.7811 67.3872 91.2215C67.1851 91.1738 67.0404 91.0065 67.0179 90.8001L64.4334 67.0695C64.4066 66.8233 64.1986 66.6367 63.9509 66.6367H47.8187C47.5782 66.6367 47.374 66.8129 47.3387 67.0507L43.807 90.8302C43.7786 91.0215 43.6335 91.179 43.4471 91.2301Z",
    fill: "#FFB951",
    stroke: "black",
    strokeWidth: 0.485317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2113 91.9546C38.5208 92.3885 34.7728 94.4481 32.7276 95.5419C32.5693 95.6265 32.4713 95.7907 32.4713 95.9702V124.952V128.272C32.4713 128.54 32.6886 128.757 32.9566 128.757H77.41C77.678 128.757 77.8953 128.54 77.8953 128.272V124.952L79.5 96.5C77.8901 95.2161 73.8067 93.1485 71.434 92.3548C71.1258 92.2517 70.8216 92.4927 70.8288 92.8177C70.9733 99.4209 70.0808 102.912 69.6364 103.29C68.2599 104.753 44.3091 105.046 42.1067 103.29C40.4356 101.957 40.4485 95.7786 40.6892 92.3979C40.7094 92.1143 40.4867 91.8839 40.2113 91.9546Z",
    fill: "#352E57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7883,
    cy: 61.2197,
    rx: 19.1507,
    ry: 24.6538,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1875 86.1115C36.3366 82.2686 35.2259 67.9158 36.6518 61.2197C38.8133 67.6829 45.5079 69.0075 48.5851 68.8619C49.4857 64.8443 53.7636 64.131 55.79 64.2766C62.6347 64.1019 66.5975 66.3873 67.7232 67.5518C71.8661 63.8836 74.2527 63.2577 74.9282 63.4032C75.1534 67.3335 72.0011 90.9152 52.1875 86.1115Z",
    fill: "#393157",
    stroke: "#393157",
    strokeWidth: 0.440246
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1561 67.6473C65.0869 68.3517 62.7976 73.2237 61.0366 75.5717C59.7159 76.4522 59.0555 76.4522 57.2945 75.1314C55.5335 73.8107 55.0933 74.4711 52.8921 75.5717C50.6908 76.6723 48.2695 75.1314 49.15 70.5089C50.0305 65.8863 53.9927 66.7668 60.1561 67.6473Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.440246
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5831 49.8239C50.6113 49.8914 50.6054 50.0072 50.4592 50.2005C50.3174 50.3879 50.0786 50.5982 49.7673 50.8171C49.1478 51.2528 48.2929 51.687 47.5161 52.012C46.7531 52.3312 46.0134 52.4757 45.4395 52.4592C44.8433 52.4421 44.5175 52.2591 44.4229 52.0328C44.3946 51.9653 44.4006 51.8495 44.5468 51.6562C44.6886 51.4688 44.9273 51.2585 45.2387 51.0396C45.8582 50.6039 46.713 50.1697 47.4898 49.8447C48.2528 49.5255 48.9925 49.381 49.5665 49.3975C50.1626 49.4146 50.4884 49.5976 50.5831 49.8239Z",
    fill: "#393157",
    stroke: "black",
    strokeWidth: 0.440246
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2554 53.0722C66.2038 53.1616 66.111 53.224 65.9396 53.2439C65.7619 53.2644 65.523 53.2347 65.2305 53.1529C64.648 52.9901 63.9215 52.6408 63.1899 52.2184C62.4567 51.7951 61.8919 51.3983 61.5589 51.0367C61.3927 50.8564 61.2969 50.6981 61.2584 50.5627C61.2221 50.4355 61.2342 50.3229 61.299 50.2106C61.4216 49.9982 61.7681 49.858 62.3615 49.9167C62.933 49.9732 63.6483 50.2105 64.3646 50.6241C65.0808 51.0376 65.644 51.5385 65.9787 52.0051C66.3262 52.4897 66.3781 52.8598 66.2554 53.0722Z",
    fill: "#393157",
    stroke: "black",
    strokeWidth: 0.440246
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.1845,
    cy: 53.9558,
    r: 0.660369,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.3919,
    cy: 55.2761,
    r: 0.660369,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9077 72.2259C56.0083 72.446 59.3102 72.2259 60.1907 69.3643",
    stroke: "black",
    strokeWidth: 0.440246,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.655 55.9365C53.2148 57.404 52.9506 60.6031 55.416 61.6597",
    stroke: "black",
    strokeWidth: 0.440246,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.6815,
    cy: 59.8992,
    r: 1.76098,
    fill: "#D5CBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1015 38.1585C35.8088 41.4185 35.3196 49.2453 36.8022 53.9264C36.9392 54.359 37.552 54.2649 37.6444 53.8206C38.6585 48.9459 42.6154 45.6855 44.8754 44.4562C45.0412 44.366 45.2479 44.4037 45.3831 44.5354C57.6418 56.4778 68.9922 52.9028 73.1838 49.5809C73.2009 49.5673 73.2167 49.5525 73.2315 49.5364C81.4657 40.6413 78.1743 31.3159 75.4601 27.7016C75.4314 27.6634 75.3953 27.6304 75.3557 27.6038C69.0087 23.3437 68.5719 28.7908 69.2325 29.9285C69.8952 31.07 70.7788 35.8639 69.2325 35.8639C68.0443 35.8639 67.5762 33.8986 67.4758 32.7992C67.468 32.7134 67.4357 32.629 67.3826 32.5611C64.8534 29.3219 63.3474 30.6973 62.8646 31.8836C62.8381 31.9487 62.831 32.0186 62.8394 32.0883C63.1166 34.3783 62.96 37.9599 60.1754 34.7226C57.3852 31.4788 55.3694 33.303 54.6798 34.6679C54.6614 34.7044 54.639 34.7381 54.6115 34.7684C52.5008 37.0893 48.812 37.9811 47.1816 38.143C47.1545 38.1457 47.1278 38.1509 47.1015 38.1585Z",
    fill: "#332C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0777 54.6164C34.6565 53.2955 31.3545 55.673 36.6375 60.7798M34.8766 56.1571H36.6375",
    stroke: "black",
    strokeWidth: 0.440246,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4488 55.8234C76.87 54.5025 80.172 56.88 74.889 61.9868M76.6499 57.3641H74.889",
    stroke: "black",
    strokeWidth: 0.440246,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.233 82.416C112.589 94.6587 114.373 115.595 113.961 125.088C113.947 125.398 113.792 125.671 113.535 125.846C105.454 131.357 91.2166 139.726 95.9373 131.071C100.737 122.271 97.9373 97.7378 95.9373 86.5711C95.4799 81.5389 99.6266 81.948 101.484 82.054C101.773 82.0705 102.047 82.1952 102.233 82.416Z",
    fill: "#FFB951",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 81.8184C101.502 88.5296 96.6645 87.3739 94.5 86.5L90 83L79.5 78C78.5 74.5 83.1688 75.1261 85.4998 76C88.6967 78.9362 90.1802 77.4493 90.5132 76.0511L84.0196 61.3703C84.0196 58.0147 86.0176 58.574 87.0166 59.2731L92.5112 69.2351L88.9999 57C91.9999 53.5 94.5092 63.2926 96.0077 67.6618L94.4999 57.5C95.6987 55.8222 97.0068 57.5251 97.5063 58.7485L99.5043 67.6618L101.003 60.3216C103.001 57.3854 103.5 62.5936 103.5 65.5647L103.001 72.3808L104 77.0996L103.5 81.8184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.836 77.7144C79.0648 78.7803 80.2068 78.7799 80.898 79.0374C84.0552 80.2779 86.861 81.665 89.8075 83.2981C90.856 83.8951 91.969 84.5097 92.8185 85.3293C93.5333 86.0085 94.0373 87.0801 94.9101 87.56C95.7829 88.04 96.8606 88.0221 97.7976 87.7582C98.7345 87.4943 99.6363 86.9786 100.474 86.4454C100.761 86.2813 101.182 85.877 101.059 85.5667C100.989 85.4437 100.942 85.3617 100.918 85.3207C100.825 85.1568 100.59 85.1276 100.426 85.2213C99.548 85.778 98.6522 86.3991 97.6508 86.6455C96.7548 86.8859 95.9055 86.8276 95.2494 86.4413C94.857 86.2306 94.5581 85.8031 94.2593 85.3757C93.1812 83.8709 93.3452 84.1578 85.3025 79.891C84.5176 79.4695 83.6917 79.0716 82.8247 78.697C81.4327 78.3553 81.2729 78.3826 80.0663 77.9847C79.3986 77.7682 79.2538 77.1775 79.7024 76.5662C80.5278 75.4415 83.0987 74.8959 85.9516 76.7457C86.4554 77.0559 86.965 77.4716 87.5273 77.6939C89.1499 78.3435 90.4322 77.447 90.5781 75.8949C90.7821 73.1129 84.2895 62.901 84.4702 60.4587C84.5244 59.7262 85.0835 59.5639 85.5176 59.3157C86.4247 59.2321 86.4953 59.6269 87.1232 60.2469C87.4573 60.9262 87.4456 61.096 88.8229 63.7897C89.2741 64.6739 89.7254 65.5581 90.206 66.5887C90.5459 67.3734 91.7004 69.4873 92.2042 69.7975C92.4678 69.9731 92.6728 69.8559 92.7547 69.809C93.1412 69.5337 92.977 68.866 91.4761 64.3393C91.0189 62.969 89.8581 59.6076 89.6116 58.2255C89.3916 56.9915 90.6636 55.2208 92.2237 58.0372C93.396 60.8481 94.5686 64.8009 95.454 67.7759C95.583 68.1916 96.2096 68.0509 96.1216 67.6116C95.6579 64.6132 95.2177 61.6557 94.7892 58.909C94.7305 58.6162 94.7363 58.3409 94.7421 58.0657C94.7523 57.576 94.8196 57.452 95.2536 57.2038C95.6876 56.9556 96.2715 56.5759 97.0908 58.4631C97.2432 58.9199 97.2784 59.1717 97.6421 60.7588C99.1378 67.4642 98.599 67.6635 99.1146 68.1846C99.2259 68.2841 99.3958 68.2958 99.5422 68.2664C100.204 67.9968 99.6413 67.0131 101.098 60.904C101.27 60.1793 102.565 58.7826 103.107 61.6589C103.347 62.9356 103.031 64.476 102.991 66.0222C102.916 70.7427 102.676 70.9888 103.064 74.1396C103.422 77.1439 103.412 79.9786 102.394 83.3348C102.265 83.6804 101.972 84.1198 101.627 84.3717C101.24 84.6471 101.633 85.2385 102.019 84.9631C102.06 84.9397 102.119 84.8518 102.16 84.8284C102.529 84.6174 102.745 84.3303 102.974 83.8734C105.25 79.199 103.591 74.1101 103.672 70.637C103.724 68.5403 103.823 66.5256 103.793 64.4757C103.898 62.9471 104.009 61.5239 103.323 60.2298C102.831 59.369 102.134 59.0061 101.39 59.3226C100.728 59.5923 100.512 60.26 100.377 60.8808C99.9152 62.8313 99.6053 64.4771 99.3248 66.2694C99.037 63.7687 98.5561 61.9767 97.9403 59.2828C97.7467 58.4688 97.5766 57.6957 97.0142 57.0927C96.4048 56.4076 95.2275 56.1562 94.566 56.8065C93.957 57.2636 93.9866 58.1713 94.0982 59.0322C94.2977 60.3324 94.5207 61.6735 94.6793 62.997C94.1634 61.3339 93.6064 59.6942 92.9441 58.0604C92.651 57.3577 92.3579 56.655 91.8014 56.1574C91.1804 55.6422 90.1729 55.4024 89.441 55.9297C88.4456 56.6622 88.8268 58.1848 88.9207 58.7294C89.5307 61.3179 91.2951 66.0202 91.9812 68.4564C91.5183 67.742 91.0905 66.8988 90.8502 66.3835C90.4105 65.3294 89.9358 64.4042 89.4436 63.5435C87.7851 60.358 87.8669 59.9304 87.1932 59.2278C86.7186 58.6833 86.0684 58.4024 85.5003 58.4553C84.5105 58.5318 83.8256 59.5218 83.7029 60.3535C83.6037 61.2262 83.8851 62.0987 84.1782 62.8014C85.8487 66.9591 89.9274 74.0913 89.7992 75.9596C89.7351 77.0841 88.8568 77.6408 87.7497 77.1316C87.2518 76.9268 86.789 76.5931 86.2618 76.2419C84.5278 75.1121 81.9038 74.3282 79.8133 75.5237C79.058 76.0101 78.496 76.9298 78.836 77.7144Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3 30C3 15.0883 15.0883 3 30 3H113C116.866 3 120 6.13401 120 10V101C120 115.912 107.912 128 93 128H30C15.0883 128 3 115.912 3 101V30Z",
    stroke: "url(#paint0_linear_1048_1636)",
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 2.5,
    width: 24,
    height: 24,
    rx: 5.58108,
    fill: "url(#paint1_linear_1048_1636)",
    stroke: "url(#paint2_linear_1048_1636)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.881 7.16342C112.978 5.3619 107.348 19.0493 107.348 19.0493C107.348 19.0493 102.229 11.0119 100.398 13.0367C97.9794 15.7102 107.384 22.1579 107.384 22.1579C107.384 22.1579 122.097 9.57073 116.881 7.16342Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1048_1636",
    x: 0.8,
    y: 0.8,
    width: 121.4,
    height: 129.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1048_1636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1048_1636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_1636",
    x1: 71.8233,
    y1: 129,
    x2: 32.1638,
    y2: 25.1767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1048_1636",
    x1: 105,
    y1: 2,
    x2: 117.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66903,
    stopColor: "#08A742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1048_1636",
    x1: 108.5,
    y1: 2,
    x2: 108.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CB6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1048_1636"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 30C2 14.536 14.536 2 30 2H113C117.418 2 121 5.58172 121 10V101C121 116.464 108.464 129 93 129H30C14.536 129 2 116.464 2 101V30Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyTick);
export default __webpack_public_path__ + "static/media/boy_tick.2f415ff6ca9f1d13dad4f9e9e9cad41a.svg";
export { ForwardRef as ReactComponent };